export const EmpresaModais = {
  cadastrarEmpresa: 'cadastrarEmpresa',
  visualizarEmpresa: 'visualizarEmpresa',
  recortarLogo: 'recortarLogo',
  alteracaoPlanoComercial: 'alteracaoPlanoComercial',
  modalSelecionarEmpresa: 'modalSelecionarEmpresa',
};
